import { WebrtcPlayer } from "@org-avp/webrtc-player";
export function getGlobalWebrtcPlayer(sessionId) {
    // Manage WebrtcPlayers in a map by ID across multiple instances of Jetstream on the same page.
    // This allows for multiple Jetstream instances to share the same WebrtcPlayer if they have the same sessionId.
    // Same sessionToken means same WebrtcPlayer and therefore same streaming connection.
    if (!sessionId) {
        return new WebrtcPlayer();
    }
    if (!window.jetstreamWebrtcPlayers) {
        window.jetstreamWebrtcPlayers = new Map();
    }
    const webrtcPlayers = window.jetstreamWebrtcPlayers;
    if (webrtcPlayers.has(sessionId)) {
        return webrtcPlayers.get(sessionId);
    }
    const webrtcPlayer = new WebrtcPlayer();
    webrtcPlayers.set(sessionId, webrtcPlayer);
    return webrtcPlayer;
}
export function removeGlobalWebrtcPlayer(sessionId) {
    if (!sessionId || !window.jetstreamWebrtcPlayers) {
        return;
    }
    if (window.jetstreamWebrtcPlayers && window.jetstreamWebrtcPlayers.has(sessionId)) {
        window.jetstreamWebrtcPlayers.delete(sessionId);
    }
}
//# sourceMappingURL=globals.js.map